import { colors } from '@insurancemenu/imenu-components-lib';
import { breakpoints } from '@insurancemenu/imenu-components-lib/dist/utils';
import { createUseStyles } from 'react-jss';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types/global';

const styles: ComponentStylesProps<boolean> = {
  modalSpacing: {
    padding: '2.4rem 6.4rem 6.4rem',
    maxHeight: '70vh',
    /* Update the ID selector below to match the ID used in your component.
    This ensures the spinner overlay covers the full height of the modal. */
    '& #modal-content-product-details': {
      position: 'relative',
    },
    [breakpoints.lg.down]: {
      padding: '2.4rem 2rem 4rem',
      width: '80%',
    },
  },
  modalBody: { paddingTop: '2.4rem', letterSpacing: '0.02rem' },
  title: {
    margin: 0,
    textAlign: 'center',
    font: {
      weight: 700,
      size: '2.8rem',
      lineHeight: '4rem',
    },
    marginBottom: '1.6rem',
  },
  effectiveDateInfo: {
    width: 'max-content',
    margin: '0 auto',
    marginBottom: '2.4rem',
    padding: '0.8rem 2.4rem',
    backgroundColor: colors.neutral[100],
    borderRadius: '20px',
    display: 'flex',
    alignItems: 'center',
    font: {
      size: '1.6rem',
      lineHeight: '2.4rem',
    },
    letterSpacing: '0.02rem',
  },
  editButton: { marginLeft: '1.5rem' },
  actionBlock: {
    borderTop: `1px solid ${colors.neutral[400]}`,
    paddingTop: '4rem',
    maxWidth: '62rem',
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto',
  },
  actionBlockTitle: {
    font: { size: '2rem', lineHeight: '2.8rem', weight: 700 },

    textAlign: 'center',
    margin: { top: '3.2rem', bottom: '0.8rem' },
  },
  actionBlockCaption: {
    margin: { bottom: '4rem' },
    color: colors.neutral[700],
    font: { size: '1.6rem', lineHeight: '2.4rem' },
    textAlign: 'center',
  },
  productLinesList: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    flexWrap: 'wrap',
    gap: '2.4rem',
    justifyContent: 'center',
    [breakpoints.sm.down]: {
      gap: '1.8rem',
    },
  },
  redirectBcButton: {
    margin: '5rem auto 0',
  },
  rateSegmentSection: {
    '&:not(:last-child)': {
      marginBottom: '4rem',
      paddingBottom: '4rem',
      borderBottom: `1px solid ${colors.neutral[400]}`,
    },
  },
  rateSegmentTitle: {
    fontSize: '1.6rem',
    textAlign: 'center',
    margin: 0,
    marginBottom: '3rem',
    '& b': {
      margin: '0 0.5rem',
    },
  },
  ancillaryButton: (showAncillaryPLines) => ({
    margin: showAncillaryPLines ? '0 auto 3rem' : '0 auto',
    minWidth: '32.2rem',
  }),
  '@media(max-width: 400px)': {
    ancillaryButton: () => ({
      minWidth: '20rem',
    }),
  },
  ancillarySection: {
    marginTop: '5rem',
  },
  ancillaryProductLineButton: {
    color: colors.purple[600],
    backgroundColor: colors.purple[100],
  },
};

const createStyles = createUseStyles(styles);

export { styles, createStyles };
